import React, { useEffect } from 'react';

import { Button, PhoneIcon } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE } from '@motorway/mw-highway-code/enums';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';
import { formatPhoneNumber } from 'Utilities/helpers';

import { PHONES } from '../../../payments/Payments.helpers';

const PaymentErrorButton = () => {
  useEffect(() => {
    captureExceptionWithTeam(
      '[PaymentErrorButton] page displayed',
      TEAM.PAYMENTS_FE,
      {
        level: 'info',
      },
    );
  }, []);

  return (
    <Button
      reverse
      as={BUTTON_AS_TYPE.ANCHOR}
      href={`tel:${PHONES.PAYMENT_ERROR}`}
      icon={PhoneIcon}
      label={`${formatPhoneNumber(PHONES.PAYMENT_ERROR).pretty}`}
    />
  );
};

export { PaymentErrorButton };
